exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".criteria-container{display:inline-block;text-align:center;margin-left:25px}.criteria-container:last-child{margin-right:25px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/Widgets/CompetitionWidgets/CompetitionCriteriasWidget.scss
 ** module id = 770
 ** module chunks = 0
 **/